import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorResponse, HttpErrorHandler } from './http-error-handler';

const DEFAULT_MESSAGE = 'Ocorreu um erro não catalogado, tente novamente mais tarde!';

@Injectable({ providedIn: 'root' })
export class HttpErrorMessageHandler extends HttpErrorHandler {
  constructor(private snackBar: MatSnackBar) {
    super();
  }

  matches(error: ErrorResponse): boolean {
    // 404 / endpoints só do HML — evita toast "erro não catalogado" em Produção.
    if (error.code === 404) {
      return false;
    }
    const url = (error.error?.url || '').toLowerCase();
    if (
      url.includes('admin-dashboard') ||
      url.includes('integration-sync') ||
      url.includes('integration-settings') ||
      url.includes('summariesbyproducer')
    ) {
      return false;
    }
    return !error.isUnauthorizedError && (error.isClientError || error.isServerError);
  }

  handle(error: ErrorResponse): void {
    this.openSnackBar(error.message || DEFAULT_MESSAGE);
  }

  private openSnackBar(message: string, duration = 3000, action: string = null) {
    this.snackBar.open(message, action, {
      duration: duration,
      panelClass: ['httpError']
    });
  }
}
